export default "__VITE_ASSET__2N$YJSKT__"